import React, { useState } from 'react'
import { Link } from 'react-router-dom'

const Decoratives = () => {

 //Mica
 const [imagesMica, setImagesMica] = useState({
    img1 : require("../Images/ply.jpg"),
    img2 : require("../Images/ply2.jpg"),
    img3 : require("../Images/ply3.jpg"),
    img4 : require("../Images/ply.jpg"),
})

const [activeMicaImg, setActiveMicaImage] = useState(imagesMica.img1)

//Glass Mica
const [imagesGlass, setimagesGlass] = useState({
    img1 : require("../Images/ply.jpg"),
    img2 : require("../Images/ply2.jpg"),
    img3 : require("../Images/ply3.jpg"),
    img4 : require("../Images/ply.jpg"),
})

const [activeGlassImg, setActiveGlassImage] = useState(imagesGlass.img1)

//Saburi
const [imagesUnicore, setimagesUnicore] = useState({
    img1 : require("../Images/ply.jpg"),
    img2 : require("../Images/ply2.jpg"),
    img3 : require("../Images/ply3.jpg"),
    img4 : require("../Images/ply.jpg"),
})

const [activeUnicoreImg, setActiveUnicoreImage] = useState(imagesUnicore.img1)


  return (
    <div className=" grid items-center ">
    <div className="bg-gray-800">
    <div className=" container mx-auto">
<nav aria-label="breadcrumb" className="w- p-4  bg-gray-800 text-gray-100">
  <ol className="flex h-8 space-x-2">
      <li className="flex items-center">
      <Link  to="/home" title="Back to homepage" className="hover:no-underline">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5 pr-1 dark:text-gray-400">
                  <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>
              </svg>
          </Link>
      </li>
      <li className="flex items-center space-x-2">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-hidden="true" fill="currentColor" className="w-2 h-2 mt-1 transform rotate-90 fill-current dark:text-gray-600">
              <path d="M32 30.031h-32l16-28.061z"></path>
          </svg>
          <Link  to="/products" className="flex items-center px-1 capitalize hover:no-underline">Products</Link>
      </li>
      <li className="flex items-center space-x-2">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-hidden="true" fill="currentColor" className="w-2 h-2 mt-1 transform rotate-90 fill-current dark:text-gray-600">
              <path d="M32 30.031h-32l16-28.061z"></path>
          </svg>
          <Link  to="/decoratives" className="flex items-center px-1 capitalize hover:no-underline">Decoratives</Link>
      </li>
      
  </ol>
</nav>
</div>
</div>



<div className="block container px-4 py-12 mx-auto">



{/* Mica */}
<div className="grid grid-cols-2  px-4 md:px-0  py-10 justify-center container mx-auto gap-10">
          <div className="col-span-full md:col-span-1 anim-product">
          <div className='flex flex-col gap-2 md:gap-6 '>
                <img src={activeMicaImg} alt="" className='w-full h-[20rem] md:h-[32rem] aspect-square object-cover rounded-xl'/>
                <div className='flex flex-row justify-between md:justify-evenly h-24'>
                    <img src={imagesMica.img1} alt="" className='w-20 md:w-24 h-20 md:h-24 rounded-md cursor-pointer' onClick={() => setActiveMicaImage(imagesMica.img1)}/>
                    <img src={imagesMica.img2} alt="" className='w-20 md:w-24 h-20 md:h-24 rounded-md cursor-pointer' onClick={() => setActiveMicaImage(imagesMica.img2)}/>
                    <img src={imagesMica.img3} alt="" className='w-20 md:w-24 h-20 md:h-24 rounded-md cursor-pointer' onClick={() => setActiveMicaImage(imagesMica.img3)}/>
                    <img src={imagesMica.img4} alt="" className='w-20 md:w-24 h-20 md:h-24 rounded-md cursor-pointer' onClick={() => setActiveMicaImage(imagesMica.img4)}/>
                </div>
            </div>
          </div>
          <div className="col-span-full md:col-span-1 flex items-center animate-slide-fade-product">
          <div className='flex flex-col Product-Sans gap-4 '>
                <div>
                    <span className='  bg-clip-text block font-semibold text-transparent bg-gradient-to-r from-amber-600 to-amber-500'>Premium Product</span>
                    <h1 className='text-3xl font-bold'>Moldings</h1>
                </div>
                <p className='text-gray-600 md:text-base xl:text-lg  font-medium'>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloremque nostrum qui quis similique sapiente unde assumenda nobis excepturi nesciunt eum! Odit culpa ipsa ullam suscipit harum.
                </p>

            

                <div className='flex flex-col md:flex-row items-center  mt-4 gap-6'>
                    <button className=' text-white font-semibold py-3  w-full md:w-1/3 bg-gradient-to-r from-amber-800 to-amber-500 text-center cursor-pointer rounded-xl h-full'> <i class="ri-download-2-line pr-2"></i> <span>Brochure</span></button>
                    <Link to="/distributers" className='cursor-pointer'>Our Vendors</Link>
                </div>
            </div>
          </div>
        </div>

{/* Glass Mica */}
        <div className="grid grid-cols-2 px-4 md:px-0  py-10 justify-center container mx-auto gap-10 ">
        <div className="col-span-full order-last md:order-first md:col-span-1 flex items-center animate-slide-fade-product">
          <div className='flex flex-col Product-Sans gap-4 '>
                <div>
                    <span className=' text-violet-60 bg-clip-text block font-semibold text-transparent bg-gradient-to-r from-amber-600 to-amber-500'>Premium Product</span>
                    <h1 className='text-3xl font-bold'>Profiles</h1>
                </div>
                <p className='text-gray-600 md:text-base xl:text-lg  font-medium'>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloremque nostrum qui quis similique sapiente unde assumenda nobis excepturi nesciunt eum! Odit culpa ipsa ullam suscipit harum.

                </p>

        

                <div className='flex flex-col md:flex-row items-center  mt-4 gap-6'>
                    <button className=' text-white font-semibold py-3  w-full md:w-1/3 bg-gradient-to-r from-amber-800 to-amber-500 text-center cursor-pointer rounded-xl h-full'> <i class="ri-download-2-line pr-2"></i> <span>Brochure</span></button>
                    <Link to="/distributers" className='cursor-pointer'>Our Vendors</Link>
                </div>
            </div>
          </div>

          <div className="col-span-full order-first md:order-last md:col-span-1 anim-product ">
          <div className='flex flex-col gap-2 md:gap-6 '>
                <img src={activeGlassImg} alt="" className='w-full h-[20rem] md:h-[32rem] aspect-square object-cover rounded-xl'/>
                <div className='flex flex-row justify-between md:justify-evenly h-24'>
                    <img src={imagesGlass.img1} alt="" className='w-20 md:w-24 h-20 md:h-24 rounded-md cursor-pointer' onClick={() => setActiveGlassImage(imagesGlass.img1)}/>
                    <img src={imagesGlass.img2} alt="" className='w-20 md:w-24 h-20 md:h-24 rounded-md cursor-pointer' onClick={() => setActiveGlassImage(imagesGlass.img2)}/>
                    <img src={imagesGlass.img3} alt="" className='w-20 md:w-24 h-20 md:h-24 rounded-md cursor-pointer' onClick={() => setActiveGlassImage(imagesGlass.img3)}/>
                    <img src={imagesGlass.img4} alt="" className='w-20 md:w-24 h-20 md:h-24 rounded-md cursor-pointer' onClick={() => setActiveGlassImage(imagesGlass.img4)}/>
                </div>
            </div>
          </div>
         
        </div>

{/* Unicore Acrylic Mica */}
<div className="grid grid-cols-2  px-4 md:px-0  py-10 justify-center container mx-auto gap-10">
          <div className="col-span-full md:col-span-1 anim-product">
          <div className='flex flex-col gap-2 md:gap-6 '>
                <img src={activeUnicoreImg} alt="" className='w-full h-[20rem] md:h-[32rem] aspect-square object-cover rounded-xl'/>
                <div className='flex flex-row justify-between md:justify-evenly h-24'>
                    <img src={imagesUnicore.img1} alt="" className='w-20 md:w-24 h-20 md:h-24 rounded-md cursor-pointer' onClick={() => setActiveUnicoreImage(imagesUnicore.img1)}/>
                    <img src={imagesUnicore.img2} alt="" className='w-20 md:w-24 h-20 md:h-24 rounded-md cursor-pointer' onClick={() => setActiveUnicoreImage(imagesUnicore.img2)}/>
                    <img src={imagesUnicore.img3} alt="" className='w-20 md:w-24 h-20 md:h-24 rounded-md cursor-pointer' onClick={() => setActiveUnicoreImage(imagesUnicore.img3)}/>
                    <img src={imagesUnicore.img4} alt="" className='w-20 md:w-24 h-20 md:h-24 rounded-md cursor-pointer' onClick={() => setActiveUnicoreImage(imagesUnicore.img4)}/>
                </div>
            </div>
          </div>
          <div className="col-span-full md:col-span-1 flex items-center animate-slide-fade-product">
          <div className='flex flex-col Product-Sans gap-4 '>
                <div>
                    <span className='  bg-clip-text block font-semibold text-transparent bg-gradient-to-r from-amber-600 to-amber-500'>Premium Product</span>
                    <h1 className='text-3xl font-bold'>Artificial Glass</h1>
                </div>
                <p className='text-gray-600 md:text-base xl:text-lg  font-medium'>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloremque nostrum qui quis similique sapiente unde assumenda nobis excepturi nesciunt eum! Odit culpa ipsa ullam suscipit harum.

                </p>

        

                <div className='flex flex-col md:flex-row items-center  mt-4 gap-6'>
                    <button className=' text-white font-semibold py-3  w-full md:w-1/3 bg-gradient-to-r from-amber-800 to-amber-500 text-center cursor-pointer rounded-xl h-full'> <i class="ri-download-2-line pr-2"></i> <span>Brochure</span></button>
                    <Link to="/distributers" className='cursor-pointer'>Our Vendors</Link>
                </div>
            </div>
          </div>
        </div>


                                    

</div>
</div>
  )
}

export default Decoratives